import { getGridStringOperators } from '@mui/x-data-grid-premium';

import { AutocompleteFilterSelector } from '../../pre-screen/NewWorklist/WorklistTable/CustomFilters/AutocompleteFilterSelector';

import { patientCardStatuses, patientStatusMap } from './constants';

const isOperator = (values, label) => {
  return {
    label: 'is',
    value: 'is',
    getApplyFilterFn: filterItem => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return value => {
        return value === filterItem.value.label;
      };
    },
    InputComponent: props => (
      <AutocompleteFilterSelector
        options={values.map(e => ({ id: e.id, label: e.name }))}
        label={label}
        placeholder="Filter value"
        {...props}
      />
    )
  };
};

const isNotOperator = (values, label) => {
  return {
    label: 'is not',
    value: 'isNot',
    getApplyFilterFn: filterItem => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return value => {
        return value !== filterItem.value.label;
      };
    },
    InputComponent: props => (
      <AutocompleteFilterSelector
        options={values.map(e => ({ id: e.id, label: e.name }))}
        label={label}
        placeholder="Filter value"
        {...props}
      />
    )
  };
};

export const patientsStatusExtendedFilterOperators = [
  ...getGridStringOperators(),
  isOperator(patientStatusMap, 'Status'),
  isNotOperator(patientStatusMap, 'Status')
];

export const patientsCardTypeExtendedFilterOperators = [
  ...getGridStringOperators(),
  isOperator(patientCardStatuses, 'Card Type'),
  isNotOperator(patientCardStatuses, 'Card Type')
];
